import get from 'lodash.get';
import set from 'lodash.set';
export function withDocumentDatesParsed(data, parseDates) {
  const doc = { ...data
  };
  parseDates === null || parseDates === void 0 ? void 0 : parseDates.forEach(dateField => {
    if (typeof dateField !== 'string') return;
    const unparsedDate = get(doc, dateField);

    if (unparsedDate) {
      var _unparsedDate$toDate;

      const parsedDate = (_unparsedDate$toDate = unparsedDate.toDate) === null || _unparsedDate$toDate === void 0 ? void 0 : _unparsedDate$toDate.call(unparsedDate);

      if (parsedDate) {
        set(doc, dateField, parsedDate);
      }
    }
  });
  return doc;
}
//# sourceMappingURL=doc-date-parser.js.map